import { render } from "./UsuarioForm.vue?vue&type=template&id=7d65744a&scoped=true"
import script from "./UsuarioForm.vue?vue&type=script&lang=js"
export * from "./UsuarioForm.vue?vue&type=script&lang=js"

import "./UsuarioForm.vue?vue&type=style&index=0&id=7d65744a&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d65744a"]])

export default __exports__